<script>
	import { api } from "../api";
	import { useParams } from "svelte-navigator";
	import FlightGrsMarkers from "../flight/FlightGrsMarkers.svelte";
	import FlightContext from "../flight/FlightContext.svelte";
	import FlightInfo from "../flight/FlightInfo.svelte";
	import FlightToolbox from "../flight/FlightToolbox.svelte";
	import ReplayTimeline from "../flight/ReplayTimeline.svelte";
	import Bounds from "../flight/Bounds.svelte";
	import OwnshipMarker from "../flight/OwnshipMarker.svelte";
	import OwnshipTrail from "../flight/OwnshipTrail.svelte";
	import RoamEvents from "../flight/RoamEvents.svelte";
	import SignalLines from "../flight/SignalLines.svelte";
	import { toolboxEnabled } from '../const'
	import ViewLink from "../flight/ViewLink.svelte";
	import GRSSidebar from "../flight/GRSSidebar.svelte"
	import '../flight/regionADSB'
  import Radar from "../flight/Radar.svelte";
  import RangeRings from "../flight/RangeRings.svelte";
    import Percepto from "../flight/Percepto.svelte";

	export let id
	export let guest = false

	const promise = api.flights.get(id)
</script>

 <svelte:head>
    {#await promise then flight}
     <title>SkyLine - {flight.name}</title>
    {/await}
</svelte:head>

{#await promise then flight}
	<FlightContext {flight} {guest}>
		<FlightGrsMarkers />
		<FlightInfo/>
		{#if $toolboxEnabled}
			<FlightToolbox/>
		{/if}
		{#if !guest}
		<ReplayTimeline>
			<RoamEvents/>
		</ReplayTimeline>
		{/if}
		<ViewLink />
		<Bounds zoom/>
		<OwnshipMarker/>
		<OwnshipTrail/>
		<SignalLines/>
		<GRSSidebar />
		<Radar />
		<Percepto />
		<RangeRings />
	</FlightContext>
{/await}